/**
 * Imaging (WP2-IMAGING-VIEW, BUILD-PLAN M09). Replaces the shell's Imaging
 * placeholder: same id and route. The chart links here with
 * `/imaging?patient=<id>&tooth=<n>` to filter films by tooth.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'imaging',
    title: 'Imaging',
    version: '0.1.0',
    owner: 'WP2-IMAGING-VIEW',
    entitlementKey: null,
    permissions: ['imaging.view', 'imaging.capture', 'chart.edit'],
    routes: [
      {
        id: 'viewer',
        path: '/imaging',
        title: 'Imaging',
        officeScope: 'location-or-all',
        permission: 'imaging.view',
        readsPhi: true,
      },
    ],
    // The nav item follows the route's imaging.view (the shell hides it from
    // roles without it); every API call checks it too.
    nav: [
      {
        label: 'Imaging',
        labelKey: 'imaging',
        group: 'clinical',
        routeId: 'viewer',
        icon: 'scan-line',
        order: 20,
      },
    ],
    commands: [
      {
        id: 'imaging.open',
        title: 'Go to Imaging',
        keywords: ['xray', 'x-ray', 'radiograph', 'bwx', 'bitewing', 'pano', 'fmx', 'films'],
        routeId: 'viewer',
      },
    ],
    shortcuts: [{ keys: 'g x', description: 'Go to Imaging', routeId: 'viewer' }],
    sseEntityKeys: ['imaging_study'],
  }),
  pages: {
    viewer: () => import('./ImagingPage.js'),
  },
});
